import union from 'lodash/union'

const paginateReports = ({ mapActionToKey, types }) => {

	const [ REQUEST_REPORTS, RECEIVE_REPORTS ] = types

	const updatePagination = (state = {
			isFetching: false,
			pageCount: 0,
			endOfDoc: undefined,
			reports: []
		}, action) => {
		switch (action.type) {
			case REQUEST_REPORTS:
				return {
					...state,
					isFetching: true
				}
			case RECEIVE_REPORTS:
				return {
					...state,
					isFetching: false,
					reports: union(state.reports, action.payload.stories),
					endOfDoc: action.payload.endOfDoc,
					pageCount: state.pageCount + 1
				}
			default:
				return state
		}
	}

	return (state = {}, action) => {
		switch (action.type) {
			case REQUEST_REPORTS:
			case RECEIVE_REPORTS:
				const key = mapActionToKey(action)
				return {
					...state,
					[key]: updatePagination(state[key], action)
				}
			default:
				return state
		}
	}
}

export default paginateReports



// WEBPACK FOOTER //
// ./src/reducers/paginateReports.js